import type { PropsWithChildren } from 'react';
import { Fieldset, Grid } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { BUSINESS_FIELDS_TRANS_PATH } from '../../constants';

export const Root: React.FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation();

  return (
    <Fieldset legend={t(`${BUSINESS_FIELDS_TRANS_PATH}.BUSINESS_LABEL`)}>
      <Grid>{children}</Grid>
    </Fieldset>
  );
};
